import { isUndefined } from 'lodash-es';

export function isValid(value?: number | null) {
  return value && !isUndefined(value);
}
